import React from "react";
import { NavLink } from "react-router-dom";
import "./Nav.scss";

const Nav = () => {
  return (
    <div className="navigation">
      <div className="navigation-list">
        <ul>
          <NavLink exact to="/" activeClassName="nav-active" style={{ textDecoration: "none" }}>
            <li>home</li>
          </NavLink>
          <NavLink to="/about" activeClassName="nav-active" style={{ textDecoration: "none" }}>
            <li>about</li>
          </NavLink>
          <NavLink to="/experience" activeClassName="nav-active" style={{ textDecoration: "none" }}>
            <li>experience</li>
          </NavLink>
          <NavLink to="/travel" activeClassName="nav-active" style={{ textDecoration: "none" }}>
            <li>travel</li>
          </NavLink>
        </ul>
      </div>
    </div>
  );
};

export default Nav;
